import React from 'react';
import {Cadenas, Mail} from "assets/icons";
// import {Delete} from "assets/icons";
import useModal from "components/modal/useModal";

const ParamsContent = () => {
    const {toggle}=useModal()
    const handleEmail = (e) => {
        e.preventDefault()
        toggle('par_u_email')
    }
    const handlePwd = (e) => {
        e.preventDefault()
        toggle('par_u_pwd')
    }
    // const handleDelete = (e) => {
    //     e.preventDefault();
    //     toggle('par_u_compte')
    // }
    return (
        <div className="w-full px-2 tab:px-4 lg:px-8 py-8">
            <div className="flex flex-col gap-8 max-w-3xl">
                <h2 className="text-xl font-semibold text-gray-900">Paramètres</h2>

                <div className="flex flex-col gap-0 max-w-md rounded-lg border border-gray-100 bg-white divide-y divide-gray-100">
                    <button
                        type="button"
                        className="w-full flex items-center gap-4 p-3 hover:bg-gray-50 transition-colors text-left"
                        onClick={handlePwd}
                    >
                        <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                            <Cadenas wh={18} color={'#111827'}/>
                        </div>
                        <div className="flex flex-col">
                            <p className="text-gray-900">Changer le mot de passe</p>
                        </div>
                    </button>

                    <button
                        type="button"
                        className="w-full flex items-center gap-4 p-3 hover:bg-gray-50 transition-colors text-left"
                        onClick={handleEmail}
                    >
                        <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                            <Mail wh={18} color={'#111827'} strokeW={2}/>
                        </div>
                        <div className="flex flex-col">
                            <p className="text-gray-900">Changer le mail</p>
                        </div>
                    </button>

                    {/* <button
                        type="button"
                        className="w-full flex items-center gap-4 p-3 hover:bg-gray-50 transition-colors text-left"
                        onClick={handleDelete}
                    >
                        <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                            <Delete wh={18} color={'#111827'}/>
                        </div>
                        <div className="flex flex-col">
                            <p className="text-gray-900">Supprimer le compte</p>
                        </div>
                    </button> */}
                </div>
            </div>
        </div>
    );
};

export default ParamsContent;